<script setup>

</script>

<template>
  <div ml="8%">
    <div w="95%" mt-24 mb-24>
      <div>
    <div class="about-warp__right--title">
      {{ $t('hzhb') }}
    </div>
    <div class="about-warp__right--content partner-box">
      <ul class="box-partners">
        <li>
          <div >
            <img style="width: 100px;" src="https://imgoss.fdzq.com/go_fd_co/fd-1636426602-u3wzrj.png">
          </div>
          <p>{{ $t('nsdkzqjys') }}</p>
        </li>
        <li>
          <div>
            <img style="width: 63px;" src="https://imgoss.fdzq.com/go_fd_co/fd-1636426639-xipkcl.png">
          </div>
          <p>{{ $t('xgjys') }}</p>
        </li>
        <li>
          <div>
            <img style="width: 100px;" src="https://imgoss.fdzq.com/go_fd_co/fd-1636426682-zrbufk.png">
          </div>
          <p>{{ $t('cx') }}</p>
        </li>
        <li>
          <div>
            <img style="width: 98px;" src="https://imgoss.fdzq.com/go_fd_co/fd-1636426711-pfitkf.png">
          </div>
          <p>{{ $t('asdkcj') }}</p>
        </li>
        <li>
          <div>
            <img style="width: 100px;" src="https://imgoss.fdzq.com/go_fd_co/fd-1634112535-o1z04k.png">
          </div>
          <p>{{ $t('lt') }}</p>
        </li>
        <li>
          <div>
            <img style="width: 72px;" src="https://imgoss.fdzq.com/go_fd_co/fd-1636426752-rwhl6b.png">
          </div>
          <p>{{ $t('hszsgs') }}</p>
        </li>
      </ul>
      <div class="tips">
        <p>{{ $t('xxpl') }}
          <br>{{ $t('yshzhbtgdsjbfyfdcpdgdfdcpgnjyytgxxbnyzxkhtjgrzhhrhqtzhzgmhcsrhzqcpdjy') }}
        </p>
        <p>
          {{ $t('sytzdsjfxgqdzqhjrcpdbxbbnbzwldjghhbqjzsrtzdyhknyzyfsfxdzdmdscztbnbzylhfzssdntzzqhqtjrcpszhyksdknxtzzztzqyzxkltzmbhfx') }}
        </p>
        <p>
          {{ $t('bxxsyzldlybrwskkddfdzqbbzqzqxhwzxfdzqbbdsybxxsbhdclcsdrhzjhjjsshycygdqtsscdrhzrbxxtjdrhzqjknhyzddfxknbybmyjbsysytzzbxxstjdzqhjrgjdjgjzjsyknhshlyxebdgwdyjbbndbwldbx') }}
        </p>
      </div>

    </div>
     </div>
    </div>

  </div>
</template>
<style lang="less" scoped>
@import "../../assets/less/main.less";
@import "../assets/css/about.less";
@media screen and (max-width: 420px) {
  body {
    .partner-box {
      padding-top: 20px!important;
      .box-partners {
        padding-bottom: 20px;
        display: grid;
        grid-gap: 30px;
        grid-template-columns:repeat(2, 1fr);
        grid-template-rows: repeat(3, 1fr);

        li {
          width: auto;
          height: auto;
          margin: 0;
          bottom: 0;

        }
      }
      .tips {
        width: 100%;
        p {
          width: 100%;
          word-wrap:break-word;

          word-break:normal;
        }

      }
    }
  }
}

.partner-box {
  padding-top: 55px !important;

  .data-title {
    font-size: 14px;
    color: #0D0E14;
    line-height: 20px;
    padding-bottom: 30px;
  }

  .box-partners {
    margin-bottom: 10px;

    li {
      vertical-align: top;
      display: inline-block;
      margin-bottom: 55px;
      margin-right: 100px;
      width: 130px;
      text-align: center;
      .font-size-line(14, 20);
      color: #61676B;
      div{
        height: 43px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      // img {
      //   vertical-align: top;
      //   /*width: 100px;*/
      //   // height: 28px;
      //   margin-bottom: 15px;
      // }

      span {
        font-size: 16px;
        color: #61676B;
      }
    }
  }

  .tips {
    padding-bottom: 40px;

    p {
      // width: 680px;
      .font-size-line(12, 20);
      color: #61676B;
      margin-bottom: 5px;
    }
  }

}
</style>
